import {Trade, ICEBlockTrade} from "../../../types/APITypes";
import AccountService from '../../../services/account.service';
import {DateTime} from "luxon";
import {fromJSDateToDateTime} from "../TradeFormatUtils";

export async function formatICEBlockTrade(iceTradeData: ICEBlockTrade): Promise<Trade> {
    const profile = JSON.parse(localStorage.getItem('userProfile') || '{}');
    const userCompany = profile.ownerShortName;
    const mappedData: Trade = {} as Trade;

    mappedData.sourceSystem = 'ICEBlock';

    let oc = iceTradeData.Option?.toUpperCase();
    if (oc) {
        mappedData.optionType = oc.startsWith('P') ? 'Put' : oc.startsWith('C') ? 'Call' : undefined;
        // @ts-ignore
        mappedData.strike = +iceTradeData["Strike Price"];
        mappedData.assetClass = 'Option';
        mappedData.price = +iceTradeData.Premium;
    } else {
        mappedData.assetClass = 'Future';
        mappedData.price = +iceTradeData.Price;
    }

    mappedData.executingBroker = userCompany;
    mappedData.productDescription = iceTradeData.Product
    mappedData.mic = iceTradeData.Hub
    mappedData.tradeID = iceTradeData["Leg ID"]?.toString();
    mappedData.instrumentCode = iceTradeData.Product;
    mappedData.quantity = +iceTradeData.Quantity;

    // Date Handling
    // @ts-ignore
    mappedData.maturity = fromJSDateToDateTime(iceTradeData.Contract)?.toISODate();
    // @ts-ignore
    let _executionTime = fromJSDateToDateTime(new Date(iceTradeData['Trade Date']));
    // @ts-ignore
    mappedData.tradeDate = _executionTime?.toISODate();
    // @ts-ignore
    mappedData.executionTime = _executionTime?.toISO();

    let _submissionTime = fromJSDateToDateTime(new Date(iceTradeData['Submission Time']));
    // @ts-ignore
    mappedData.giveupTime = _submissionTime?.toISO();


    if (iceTradeData['Seller Clearing Acct'] || iceTradeData['Buyer Clearing Acct']) {

        const setParties = (
            side:string, owner:string, name:string,
            client:string, clientTrader:string|undefined,
            contraBroker: string|undefined,
            contraTrader: string|undefined) => {
            mappedData.side = side;
            mappedData.clearingBroker = owner
            mappedData.clearingAccount = name;
            mappedData.client = client;
            mappedData.clientTrader = clientTrader;
            mappedData.contraBroker = contraBroker;
            mappedData.contraTrader = contraTrader;
        };

        const storageKeys = ['axios-cache-account', 'axios-cache-alias'];
        for (const key of storageKeys) {
            const storedData = localStorage.getItem(key);
            if (storedData) {
                try {
                    const item = JSON.parse(storedData);
                    if (!item) {
                        console.log('Warning alias and account caches may not be pre-loaded');
                    }
                    item.data.data.result?.forEach((entry: {
                        owner: string;
                        client: string;
                        name: string
                    }) => {
                        // @todo why do account number strings get converted to numbers when cached.??
                        if (iceTradeData['Seller Clearing Acct']?.toString() === entry.name?.toString()) {
                            setParties('Sell', entry.owner, entry.name, entry.client,
                                iceTradeData.Seller?.toString(), iceTradeData["Buyer Company"]?.toString(), iceTradeData.Buyer?.toString());
                        } else if (iceTradeData['Buyer Clearing Acct']?.toString() === entry.name?.toString()) {
                            setParties('Buy', entry.owner, entry.name, entry.client,
                                iceTradeData.Buyer?.toString(), iceTradeData["Seller Company"]?.toString(), iceTradeData.Seller?.toString());
                        }
                    });
                    if (mappedData['side']) {
                        break;
                    }
                } catch (e) {
                    console.error('Failed to parse JSON for key:', key, e);
                }
            }
        }

        if (!mappedData.side) {
            const sellerAccount = iceTradeData['Seller Clearing Acct'] ? await AccountService.getAccountOrAlias(iceTradeData['Seller Clearing Acct']) : undefined;
            if (sellerAccount?.result) {
                setParties('Sell', sellerAccount.result?.owner, sellerAccount.result?.name,
                    sellerAccount.result?.client,
                    iceTradeData.Seller?.toString(),
                    iceTradeData["Buyer Company"]?.toString(),
                    iceTradeData.Buyer?.toString());
            } else {
                const buyerAccount = iceTradeData['Buyer Clearing Acct'] ? await AccountService.getAccountOrAlias(iceTradeData['Buyer Clearing Acct']) : undefined;
                if (buyerAccount?.result) {
                    setParties('Buy', buyerAccount.result?.owner, buyerAccount.result?.name,
                        buyerAccount.result?.client,
                        iceTradeData.Buyer?.toString(),
                        iceTradeData["Seller Company"]?.toString(),
                        iceTradeData.Seller?.toString());
                }
            }
        }
    }

    return mappedData;
}
